/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from "react";
import {Button, Grid, Paper, TextField, ThemeProvider} from "@mui/material";
import {SEText} from "../../../../components/SEText";
import {Controller, useForm} from "react-hook-form";
import {VersionamentoAppInterface} from "../../../../interfaces";
import {VersionamentoAppService} from "../services";
import useRenderFormStore from "../../stores/useRenderFormStore";
import {removeEmpty, sortByDirection} from "../../../../../utils/utils";
import {BaSeDialogContext} from "@base/react";
import useFormMutation from "../../hooks/useFormMutation";
import theme from "../../../../mui-theme";
import {useHistory} from "react-router-dom";
import {useLocation} from "react-router";
import {TextFieldCounter} from "../../../../components/TextFieldCounter";
import {SEFormUserAction} from "../../../../components/SEFormUserAction";
import SEFilterSelect from "../../../../components/SEFilterSelect";
import {useQuery} from "react-query";
import styled from "styled-components";
import {RiSearchLine} from "react-icons/ri";

const CustomIcon = styled(RiSearchLine)(({theme}) => ({
    fill: theme.palette.primary.main,
    height: 26,
    width: 26,
    top: "calc(50% - .75em) !important",
}));

const Formulario = () => {

    const {showModal} = React.useContext(BaSeDialogContext);
    const history = useHistory();
    const location = useLocation();
    const hasCopyParam = location.pathname.includes('/copy');

    const {formData: editFormData, handleShowForm} = useRenderFormStore();

    const defaultData: VersionamentoAppInterface = {
        versao: '',
        plataforma: '',
    }

    const [formData] = useState<VersionamentoAppInterface>(editFormData?.id ? editFormData : defaultData);

    const {control, handleSubmit, reset} = useForm<VersionamentoAppInterface>({
        defaultValues: formData,
    });
    const onResetFields = () => {
        reset(defaultData);
    };

    const goBack = () => {
        handleShowForm(false);
        history.push(`/tabelas-de-controle/versionamento-app`);
    };

    const {
        data: filterOptions,
    } = useQuery({
        queryFn: () => VersionamentoAppService.getOptions(),
        queryKey: ["getOptions"],
        refetchOnMount: false,
    });


    const {
        createMutation,
        updateMutation,
    } = useFormMutation({
        showModal,
        service: VersionamentoAppService,
        onCloseModalSuccess: () => {
            onResetFields();
            goBack()
        },
        onCloseModalUpdate: () => goBack(),
        onCloseModalError: () => {
        },
    });

    const submitForm = async (dataForm: VersionamentoAppInterface) => {
        if (hasCopyParam) {
            delete dataForm.id;
        }
        const cleanedData = removeEmpty(dataForm);
        if (dataForm.id) {
            await updateMutation(cleanedData).then();
        } else {
            await createMutation(cleanedData).then();
        }
    };

    return (
        <Paper
            sx={{
                display: "flex",
                alignItems: "center",
                padding: 2,
            }}
        >
            <ThemeProvider theme={theme}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SEText
                            as="h2"
                            size={"medium"}
                            font="Mulish"
                            weight="bold"
                            color="#7B80FF"
                        >
                            {editFormData?.id ? (hasCopyParam ? 'Copiar' : 'Editar') : 'Incluir'}
                        </SEText>
                    </Grid>

                    <Grid container item spacing={3}>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="plataforma"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <SEFilterSelect
                                            id={"plataforma"}
                                            defaultOption={"Selecione uma das opções"}
                                            IconComponent={CustomIcon}
                                            label="Plataforma *"
                                            value={value}
                                            onChange={onChange}
                                            options={sortByDirection(filterOptions?.plataforma)}
                                            error={error}
                                        />
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                    </Grid>

                    <Grid container item spacing={3}>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="versao"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({field: {value, onChange}, fieldState: {error}}) => (
                                    <>
                                        <TextField
                                            id="tipo"
                                            label="Versão *"
                                            placeholder="Digite o tipo de registro"
                                            fullWidth
                                            value={value || ""}
                                            onChange={onChange}
                                            inputProps={{maxLength: 20}}
                                        />
                                        <TextFieldCounter value={value} maxLength={20}/>
                                        {error && (
                                            <p style={{color: 'red', marginTop: '8px'}}>{error.message}</p>
                                        )}
                                    </>
                                )}
                            />
                        </Grid>

                    </Grid>

                    <Grid item md={12} display="flex" justifyContent="flex-end" gap={2}>
                        <Button variant="outlined" onClick={goBack}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleSubmit(submitForm)}
                            disabled={false}
                        >
                            {editFormData?.id ? 'Editar' : 'Incluir'}
                        </Button>
                    </Grid>

                    <Grid item md={12}>
                        <SEFormUserAction data={editFormData}/>
                    </Grid>
                </Grid>
            </ThemeProvider>
        </Paper>
    );
};

export default Formulario;
